<template>
    <div>
        <button class="btn btn-danger" @click="show">Delete</button>

        <transition name="modal">
            <div class="modal-mask" v-if="visible">
                <div class="modal-wrapper centered">
                    <div class="modal-container">
                        <div class="container">
                            <div class="modal-header">
                                <div class="row">
                                    <div class="col">
                                        <h1 v-text="title"></h1>
                                    </div>
                                    <div class="col-auto">
                                        <div aria-label="Close modal window" class="modal-default-button fa fa-window-close d-print-none" @click="cancel"></div>
                                    </div>
                                </div>
                            </div>

                            <div class="modal-body">
                                <slot>
                                    <p>
                                        Are you sure you want to delete this?
                                    </p>
                                </slot>
                                <div class="submit">
                                    <div class="d-flex justify-content-between">
                                       <button class="btn btn-danger" @click="confirm">Delete</button>
                                       <button class="btn" @click="cancel">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>

export default {
    props: ['id', 'title', 'label'],

    data: () => ({
        visible: false,
    }),

    methods: {
        show() {
            this.visible = true;
        },
        cancel() {
            this.visible = false;
            this.$emit('cancelled');
        },
        confirm() {
            this.visible = false;
            this.$emit('confirmed');
        },
    },
}
</script>
